export const SEO_MODULE_GLOBAL = Symbol('seoModuleGlobal');
export const SEO_MODULE_PRODUCT = Symbol('seoModuleProduct');
export const SEO_MODULE_CATEGORY = Symbol('seoModuleCategory');
export const SEO_MODULE_CMS = Symbol('seoModuleCms');
export const SEO_MODULE_SDS = Symbol('seoModuleSDS');
export const SEO_MODULE_CATALOG = Symbol('seoModuleCatalog');
export const SEO_MODULE_GIFT_CARD_REQUEST = Symbol('seoModuleGiftCardRequest');
export const SEO_MODULE_CSR = Symbol('seoModuleCsr');
export const SEO_MODULE_LOYALTY_FAQ = Symbol('seoModuleLoyaltyFaq');
export const SEO_MODULE_PETROL_FAQ = Symbol('seoModulePetrolFaq');
export const SEO_MODULE_FAQ = Symbol('seoModuleFaq');
export const SEO_MODULE_FOOD_DELIVERY_MAP = Symbol('seoModuleFoodDeliveryMap');
export const SEO_MODULE_INSPIRATIONS = Symbol('seoModuleInspirations');
export const SEO_MODULE_NEWS = Symbol('seoModuleNews');
export const SEO_MODULE_PRESS = Symbol('seoModulePress');
export const SEO_MODULE_PRIZE_GAME = Symbol('seoModulePrizeGame');
export const SEO_MODULE_UNSUBSCRIBE = Symbol('seoModuleUnsubscribe');
export const SEO_MODULE_COMPARE = Symbol('seoModuleCompare');
export const SEO_MODULE_CAREER_NEWS = Symbol('seoModuleCareerNews');
export const SEO_MODULE_CAREER_JOB = Symbol('seoModuleCareerJob');
export const SEO_MODULE_BASKET = Symbol('seoModuleBasket');
export const SEO_MODULE_STORE = Symbol('seoModuleStore');
export const SEO_MODULE_PETROL = Symbol('seoModulePetrol');
export const SEO_MODULE_SHORTLIST = Symbol('seoModuleShortlist');
